export default __webpack_public_path__ + "static/media/Surberec's Collar.a9833e52.jpg";